import classNames from 'classnames'

import { Spinner } from '../../../components/Spinner/Spinner'
import { DocumentProcessingStatusType, DocumentRecord } from '../../../models/Document'
import { useDocumentProcessingStatus } from '../DocumentUpload/hooks'

import './DocumentProcessingStatus.scss'

const _CONTAINER_CLASS_NAME_MAPPING: Partial<Record<DocumentProcessingStatusType, string>> = {
  [DocumentProcessingStatusType.SAVED]: 'border zocks-border-0.5 zocks-border-color-gray-400',
  [DocumentProcessingStatusType.READY]: 'border zocks-border-0.5 zocks-border-color-gray-400',
}

const _STATUS_TEXT_MAPPING = {
  [DocumentProcessingStatusType.SAVED]: 'Saved to external system',
  [DocumentProcessingStatusType.READY]: 'Not saved, ready for review',
  [DocumentProcessingStatusType.LOADING]: 'Checking status',
  [DocumentProcessingStatusType.PROCESSING]: 'Extracting insights',
}

const _STATUS_TEXT_CLASS_NAME_MAPPING = {
  [DocumentProcessingStatusType.SAVED]: 'bold',
  [DocumentProcessingStatusType.READY]: 'bold',
  [DocumentProcessingStatusType.LOADING]: 'zocks-text-gray-600',
  [DocumentProcessingStatusType.PROCESSING]: 'zocks-text-gray-600',
}

const _ICON_CLASS_NAME_MAPPING: Partial<Record<DocumentProcessingStatusType, string>> = {
  [DocumentProcessingStatusType.SAVED]: 'document-processing-completed-icon-container rounded-circle',
}

const _STATUS_ICON_MAPPING = {
  [DocumentProcessingStatusType.SAVED]: <i className='bi bi-check zocks-text-white' />,
  [DocumentProcessingStatusType.READY]: (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <circle cx='8' cy='8' r='6.5' fill='white' stroke='#ADB5BD' strokeWidth='3' />
    </svg>
  ),
  [DocumentProcessingStatusType.LOADING]: <Spinner size='sm' />,
  [DocumentProcessingStatusType.PROCESSING]: <Spinner size='sm' />,
}

interface DocumentProcessingStatusProps {
  document: DocumentRecord
}

export const DocumentProcessingStatus: React.FC<DocumentProcessingStatusProps> = ({ document }) => {
  const { processingStatusType } = useDocumentProcessingStatus(document)

  const containerClassName = _CONTAINER_CLASS_NAME_MAPPING[processingStatusType]
  const iconClassName = _ICON_CLASS_NAME_MAPPING[processingStatusType]
  const statusTextClassName = _STATUS_TEXT_CLASS_NAME_MAPPING[processingStatusType]

  return (
    <div className={classNames('px-2 py-1 d-flex align-items-center gap-2 document-processing-status-container', containerClassName)}>
      <div className={classNames('document-processing-icon-container d-flex align-items-center justify-content-center', iconClassName)}>
        {_STATUS_ICON_MAPPING[processingStatusType]}
      </div>
      <span className={classNames('paragraph-small text-nowrap', statusTextClassName)}>{_STATUS_TEXT_MAPPING[processingStatusType]}</span>
    </div>
  )
}
